<template>
    <router-view/>
</template>

<style>
  @import 'vue-select/dist/vue-select.css';
  @import "assets/css/plugins.bundle.css";
  @import "assets/css/style.bundle.css";
  @import "assets/css/custom.css";
</style>
<script>
</script>